import CryptoJS from 'crypto-js';

const { VITE_PRIVATE_INFO_KEY } = import.meta.env;
const ACCESS_KEY = VITE_PRIVATE_INFO_KEY;

export interface PrivateUserInfo {
  userName: string;
  dbName: string;
}

export interface LoginValues {
  UserName: string;
  password: string;
  checked: null;
}

export class StorageService {
  saveUserCredentials(userName: string): void {
    const encryptedUserData = CryptoJS.AES.encrypt(JSON.stringify({ UserName: userName }), ACCESS_KEY).toString();
    localStorage.setItem('privateInfo', encryptedUserData);
  }

  clearSavedCredentials(): void {
    localStorage.removeItem('privateInfo');
    sessionStorage.removeItem('privateInfo');
  }

  saveUserName(userName: string): void {
    localStorage.setItem('userName', userName);
  }

  getSavedCredentials(): LoginValues {
    const encryptedUserData = localStorage.getItem('privateInfo');
    if (encryptedUserData) {
      try {
        const decryptedData = CryptoJS.AES.decrypt(encryptedUserData, ACCESS_KEY).toString(CryptoJS.enc.Utf8);
        const { UserName } = JSON.parse(decryptedData);

        return {
          UserName,
          password: '',
          checked: null,
        };
      } catch (error) {
        console.error('Error decrypting user data', error);
      }
    }

    return {
      UserName: '',
      password: '',
      checked: null,
    };
  }
}
